<!-- =========================================================================================
    File Name: ProductEdit.vue
    Description: Edit Product
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">
        <h4 class="text-danger"> {{ $t("ProductEditDescription") }} </h4>
        <br>
        <form @submit.prevent="submitForm">
            <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Product Group </span>
                    <v-select v-model="ProductGroupId" name="ProductGroupId" :value="ProductGroupId" :options="ProductGroupIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('ProductGroupId')">{{ errors.first('ProductGroupId') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Product Name" v-model="ProductName" v-validate="'required'" name="ProductName" icon-pack="fa" icon="fa-pen-square" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductName')">{{ errors.first('ProductName') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Product Regional Name" v-model="ProductRegionalName"  name="ProductRegionalName" icon-pack="fa" icon="fa-language" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductRegionalName')">{{ errors.first('ProductRegionalName') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Product Hsn Code" v-model="ProductHsnCode" name="ProductHsnCode" icon-pack="fa" icon="fa-receipt" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductHsnCode')">{{ errors.first('ProductHsnCode') }}</span>
                </div>                
            </div>

            <div class="vx-row">

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> GST Slab </span>
                    <v-select v-model="GstSlabId" name="GstSlabId" :value="GstSlabId" :options="GstSlabIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('GstSlabId')">{{ errors.first('GstSlabId') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Product Image1 </span>
                    <input type="file" id="ProductImage1" ref="ProductImage1" v-on:change="handleFileUpload()" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductImage1')">{{ errors.first('ProductImage1') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Product Image2 </span>
                    <input type="file" id="ProductImage2" ref="ProductImage2" v-on:change="handleFileUpload()" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductImage2')">{{ errors.first('ProductImage2') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Product Image3 </span>
                    <input type="file" id="ProductImage3" ref="ProductImage3" v-on:change="handleFileUpload()" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductImage3')">{{ errors.first('ProductImage3') }}</span>
                </div>
            </div>

            <h4 class="text-danger">Product Stock Details</h4>

            <div class="vx-row">

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Variant Attribute Name" v-model="VariantAttributeName"  v-validate="'required'" name="VariantAttributeName" />
                    <span class="text-danger text-sm" v-show="errors.has('VariantAttributeName')">{{ errors.first ('VariantAttributeName') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Custom Code" v-model="CustomCode" v-validate="'required'" name="CustomCode" :readonly="true" icon-pack="fa" icon="fa-barcode" />
                    <span class="text-danger text-sm" v-show="errors.has('CustomCode')">{{ errors.first('CustomCode') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Product Description" v-model="ProductDescription"  v-validate="'required'" name="ProductDescription" icon-pack="fa" icon="fa-file-alt" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductDescription')">{{ errors.first('ProductDescription') }}</span>
                </div>                

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Opening Stock" v-model="OpeningStock" v-validate="'required|decimal:3|min_value:0'"  name="OpeningStock" icon-pack="fa" icon="fa-cubes" />
                    <span class="text-danger text-sm" v-show="errors.has('OpeningStock')">{{ errors.first('OpeningStock') }}</span>
                </div>
                
            </div>

            <div class="vx-row">

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Production Cost" v-model="ProductionCost" v-validate="'required|decimal:2|min_value:0'" name="ProductionCost" icon-pack="fa" icon="fa-coins" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductionCost')">{{ errors.first('ProductionCost') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Base Unit </span>
                    <v-select v-model="UnitId" name="UnitId" :value="UnitId" :options="UnitIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('UnitId')">{{ errors.first('UnitId') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <span class="text-primary text-sm vs-placeholder-label"> Sub Unit </span>
                    <v-select v-model="SubUnitId" name="SubUnitId" :value="SubUnitId" :options="UnitIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('SubUnitId')">{{ errors.first('SubUnitId') }}</span>
                </div>

                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <vs-input class="w-full" label-placeholder="Convertion Rate" v-model="ConversionRate" v-validate="'required|decimal:3|min_value:0.001'" name="ConversionRate" icon-pack="fa" icon="fa-percentage" />
                    <span class="text-danger text-sm" v-show="errors.has('ConversionRate')">{{ errors.first('ConversionRate') }}</span>
                </div>

            </div>
            
            <div class="vx-row">
                <div class="vx-col sm:w-1/4 w-full mb-3">
                    <v-select v-model="ActiveStatus" name="ActiveStatus" :value="ActiveStatus" :options="ActiveStatusOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('ActiveStatus')">{{ errors.first('ActiveStatus') }}</span>
                </div>                
            </div>

            <div class="vx-row">
                <div class="vx-col w-full text-right mb-3">
                    <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                    <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select'
import ProductVariantEditTable from "./ProductVariantEditTable.vue"

const dict = {
    custom: {

        ProductGroupId: {
            required : 'Product Group should not be empty',
            numeric: 'Select valid Product Group', 
        },
        ProductName: { required : 'Product Name should not be empty', },
        ProductRegionalName: { required : 'Product Regional Name should not be empty', },
        ProductHsnCode: { required : 'Product Hsn Code should not be empty', },
        GstSlabId: {
            required : 'GST Slab should not be empty',
            numeric: 'Select valid GST Slab', 
        },
        ProductImage1: { required : 'Product Image1 should not be empty', },
        ProductImage2: { required : 'Product Image2 should not be empty', },
        ProductImage3: { required : 'Product Image3 should not be empty', },
        HasVariant: { required : 'Has Variant should not be empty', },
        OpeningStock: {
            required : 'Opening Stock should not be empty',
            decimal: 'Enter valid number with 3 decimal places only',
            min_value: 'Opening Stock should be greater than or equal to 0'
        },
        ProductionCost: {
            required : 'Production Cost should not be empty',
            decimal: 'Enter valid number with 2 decimal places only',
            min_value: 'Production Cost should be greater than 0'
        },
        UnitId: {
            required : 'Product Base Unit should not be empty',
        },
        SubUnitId: {
            required : 'Product Sub Unit should not be empty',
        },
        ConversionRate: {
            required : 'Conversion Rate should not be empty',
            decimal: 'Enter valid number with 3 decimal places only',
            min_value: 'Conversion Rate should be greater than 0.001'
        },
        ActiveStatus: {
            required: 'Active Status should not be empty',
            numeric: 'Active Status is invalid', 
        },        
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
        ProductVariantEditTable
    },
    props: {
        editRecordPrompt: {
            type: Boolean,
            required: true,
        },
        recordIndex: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            // activePrompt: false,
            ProductGroupIdOptions : [],
            GstSlabIdOptions : [],
            UnitIdOptions: [],
            ActiveStatusOptions : this.selectListActiveStatus(),

            ProductId: this.$store.state.product.dataArray[this.recordIndex].ProductId,
            ProductVariantId: this.$store.state.product.dataArray[this.recordIndex].ProductVariantId,
            ProductGroupId: this.$store.state.product.dataArray[this.recordIndex].ProductGroupId,
            ProductName: this.$store.state.product.dataArray[this.recordIndex].ProductName,
            ProductRegionalName: this.$store.state.product.dataArray[this.recordIndex].ProductRegionalName,
            ProductHsnCode: this.$store.state.product.dataArray[this.recordIndex].ProductHsnCode,
            GstSlabId: this.$store.state.product.dataArray[this.recordIndex].GstSlabId,
            ProductImage1: this.$store.state.product.dataArray[this.recordIndex].ProductImage1,
            ProductImage2: this.$store.state.product.dataArray[this.recordIndex].ProductImage2,
            ProductImage3: this.$store.state.product.dataArray[this.recordIndex].ProductImage3,

            VariantAttributeId: this.$store.state.product.dataArray[this.recordIndex].VariantAttributesValuesId,
            VariantAttributeName: this.$store.state.product.dataArray[this.recordIndex].VariantAttributesContent,
            CustomCode: this.$store.state.product.dataArray[this.recordIndex].ProductCustomCode,
            ProductDescription: this.$store.state.product.dataArray[this.recordIndex].ProductDescription,
            OpeningStock: this.$store.state.product.dataArray[this.recordIndex].OpeningStock,
            ProductionCost: this.$store.state.product.dataArray[this.recordIndex].ProductionCost,
            UnitId: this.$store.state.product.dataArray[this.recordIndex].UnitId,
            SubUnitId: this.$store.state.product.dataArray[this.recordIndex].SubUnitId,
            ConversionRate: this.$store.state.product.dataArray[this.recordIndex].ConversionRate,
            ActiveStatus: this.$store.state.product.dataArray[this.recordIndex].ActiveStatus,

            Products: [{
                VariantProductId: '',
                VariantAttributeId: '',
                VariantAttributeName: '',
                CustomCode: '',
                ProductDescription: '',
                OpeningStock: 0,
                ProductionCost : '',
                UnitId : '',
                SubUnitId : '',
                ConversionRate : 1,
            }],

            showProductVariantTable: true,
            record: {},            
        }
    },
    computed: {
        allProducts(){
            return this.$store.getters['product/dataList'];
        },        
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideEditRecordPrompt');
        },        
        handleFileUpload(){
            this.ProductImage1 = this.$refs.ProductImage1.files[0];
            console.log('ProductImage1='+JSON.stringify(this.ProductImage1));

            this.ProductImage2 = this.$refs.ProductImage2.files[0];
            console.log('ProductImage2='+JSON.stringify(this.ProductImage2));

            this.ProductImage3 = this.$refs.ProductImage3.files[0];
            console.log('ProductImage3='+JSON.stringify(this.ProductImage3));
        },        
        updateRecordDetails() {

            var recordObj = {
                "VariantAttributeId" :  this.VariantAttributeId, 
                "ProductGroupId" :  this.ProductGroupId, 
                "ProductName" :  this.ProductName, 
                "ProductRegionalName" :  this.ProductRegionalName, 
                "ProductHsnCode" :  this.ProductHsnCode, 
                "GstSlabId" :  this.GstSlabId, 
                "ProductImage1" :  this.ProductImage1, 
                "ProductImage2" :  this.ProductImage2, 
                "ProductImage3" :  this.ProductImage3, 
                "VariantAttributeName" :  this.VariantAttributeName, 
                "CustomCode" :  this.CustomCode, 
                "ProductDescription" :  this.ProductDescription, 
                "OpeningStock" :  this.OpeningStock, 
                "ProductionCost" :  this.ProductionCost, 
                "UnitId" :  this.UnitId, 
                "SubUnitId" :  this.SubUnitId, 
                "ConversionRate" :  this.ConversionRate, 
                "ActiveStatus" :  this.ActiveStatus, 
            };

            var server_url=companyConfig.apiURL;
            this.record.token=this.$session.get('token');
            this.record.update_url=server_url+'lib/api/product/product/update';
            this.record.where={
                "ProductId" :  this.ProductId, 
                "ProductVariantId" :  this.ProductVariantId,
            };
            this.record.form=recordObj;
            this.record.list_url=server_url+'lib/api/product/product/lists';
            this.record.list_where={};
            console.log('record='+JSON.stringify(this.record));
            this.record.loading=this.$vs.loading;
            this.record.notify=this.$vs.notify;
            this.record.http=this.$http;                        
            this.$store.dispatch('product/updateRecordDetails', this.record);

            this.closePrompt();
        },
        init() {
            // clear all fileds in todo
            this.ProductId = this.$store.state.product.dataArray[this.recordIndex].ProductId,
            this.ProductVariantId = this.$store.state.product.dataArray[this.recordIndex].ProductVariantId,
            this.VariantAttributeId = this.$store.state.product.dataArray[this.recordIndex].VariantAttributesValuesId,
            this.ProductGroupId = this.$store.state.product.dataArray[this.recordIndex].ProductGroupId,
            this.ProductName = this.$store.state.product.dataArray[this.recordIndex].ProductName,
            this.ProductRegionalName = this.$store.state.product.dataArray[this.recordIndex].ProductRegionalName,
            this.ProductHsnCode = this.$store.state.product.dataArray[this.recordIndex].ProductHsnCode,
            this.GstSlabId = this.$store.state.product.dataArray[this.recordIndex].GstSlabId,
            this.ProductImage1 = this.$store.state.product.dataArray[this.recordIndex].ProductImage1,
            this.ProductImage2 = this.$store.state.product.dataArray[this.recordIndex].ProductImage2,
            this.ProductImage3 = this.$store.state.product.dataArray[this.recordIndex].ProductImage3,
            this.VariantAttributeName = this.$store.state.product.dataArray[this.recordIndex].VariantAttributesContent,
            this.CustomCode = this.$store.state.product.dataArray[this.recordIndex].ProductCustomCode,
            this.ProductDescription = this.$store.state.product.dataArray[this.recordIndex].ProductDescription,
            this.OpeningStock = this.$store.state.product.dataArray[this.recordIndex].OpeningStock,
            this.ProductionCost = this.$store.state.product.dataArray[this.recordIndex].ProductionCost,
            this.UnitId = this.$store.state.product.dataArray[this.recordIndex].UnitId,
            this.SubUnitId = this.$store.state.product.dataArray[this.recordIndex].SubUnitId,
            this.ConversionRate = this.$store.state.product.dataArray[this.recordIndex].ConversionRate,
            this.ActiveStatus = this.$store.state.product.dataArray[this.recordIndex].ActiveStatus,

            
            this.$parent.editRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.updateRecordDetails();
            })
        },
        checkCustomCode() {
            console.log('checkCustomCode called');
            var temp_code=this.CustomCode;
            console.log('temp_code='+temp_code);
            console.log('allProducts='+JSON.stringify(this.allProducts));
            var idx = this.allProducts.map(e => e.ProductCustomCode).indexOf(temp_code);
            console.log('idx='+idx);            
            if (idx >= 0) {                
                var message='Product custom code is already exist';
                this.errorMessage(message);
                // this.LocalVariantProducts[index].CustomCode = '';
                this.CustomCode="";
            }
            /*
            var idx = this.LocalVariantProducts.indexOf(VariantProduct);
            console.log(idx, index);
            */
            
        },
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            console.log('token='+token);
            
            var selectbox1_source = 'ProductGroupId'
            var selectbox1_destination = 'ProductGroupIdOptions'
            var selectbox1_url = 'lib/api/data/get_product_group_options'
            var selectbox1_conditions_array = {
                'product_group_id > ': 0
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)
            
            var selectbox2_source = 'GstSlabId'
            var selectbox2_destination = 'GstSlabIdOptions'
            var selectbox2_url = 'lib/api/data/get_gst_slab_options'
            var selectbox2_conditions_array = {
                'gst_slab_id > ': 0
            }
            this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url)

            var selectbox3_source = 'UnitId'
            var selectbox3_destination = 'UnitIdOptions'
            var selectbox3_url = 'lib/api/data/get_product_unit_options'
            var selectbox3_conditions_array = {
                'product_unit_id > ': 0
            }
            this.getSelectBoxOptions(selectbox3_source, selectbox3_destination, selectbox3_conditions_array, selectbox3_url)
            
        }
    },
    watch: {
        ProductGroupIdOptions: function(){            
            console.log('watch ProductGroupIdOptions='+JSON.stringify(this.ProductGroupIdOptions));
            var n1=this.ProductGroupIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.ProductGroupIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.ProductGroupId;
                var str2=str1.toString();
                console.log('str1='+str1+', str2='+str2);                
                this.ProductGroupId=str2 != "" ? str2 : temp;
            }
        },
        GstSlabIdOptions: function(){            
            console.log('watch GstSlabIdOptions='+JSON.stringify(this.GstSlabIdOptions));
            var n1=this.GstSlabIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.GstSlabIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.GstSlabId;
                var str2=str1.toString();
                console.log('str1='+str1+', str2='+str2);                
                this.GstSlabId=str2 != "" ? str2 : temp;
            }
        },
        UnitIdOptions: function(){            
            console.log('watch UnitIdOptions='+JSON.stringify(this.UnitIdOptions));
            var n1=this.UnitIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.UnitIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.UnitId;
                var str2=str1.toString();
                console.log('str1='+str1+', str2='+str2);                
                this.UnitId=str2 != "" ? str2 : temp;

                var str3=this.SubUnitId;
                var str4=str1.toString();
                console.log('str3='+str3+', str4='+str4);                
                this.SubUnitId=str4 != "" ? str4 : temp;                
            }
        },
        
        HasVariant: function(){
            var temp1=this.HasVariant;
            console.log('watch HasVariant='+temp1);
            if (temp1 == 1) {
                this.showProductVariantTable = true;
            }else{
                this.Products = [];
                this.showProductVariantTable = false;
            }
        },
    },
}
</script>
<style>
/*
.con-vs-popup .vs-popup {
    width: 950px;
}
*/
</style>